"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtrasCarousel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Carousel_1 = require("../../carousel/Carousel");
var HomeLegalExpensesBanner_1 = require("./HomeLegalExpensesBanner");
var HomeEmergencyBanner_1 = require("./HomeEmergencyBanner");
var services_1 = require("@falcon/services");
var BicyclesBanner_1 = require("./BicyclesBanner");
var commonFunctions_1 = require("../../../commonFunctions");
var ExtrasCarousel = /** @class */ (function (_super) {
    __extends(ExtrasCarousel, _super);
    function ExtrasCarousel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtrasCarousel.prototype.getBanners = function (availableBannersConfig) {
        var _a, _b, _c;
        var banners = [];
        var isGold = this.props.interaction.coverTier === services_1.GOLD_TIER;
        var isOwned = (0, commonFunctions_1.isPropertyOwned)(this.props.interaction.realEstate[0].ownershipType);
        var isBuildingsOnlyCover = this.props.interaction.coverLevel === "BUILDINGS";
        if (!isGold
            && !((_a = this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.homeEmergency)
            && isOwned) {
            banners.push({
                id: 1,
                product: services_1.ProductsEnum.HOME,
                name: "HomeEmergencyBanner",
                link: "",
                component: (0, jsx_runtime_1.jsx)(HomeEmergencyBanner_1.HomeEmergencyBanner, __assign({}, this.props))
            });
        }
        if (!isGold && !((_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.homeLegalExpenses)) {
            banners.push({
                id: 2,
                product: services_1.ProductsEnum.HOME,
                name: "HomeLegalExpensesBanner",
                link: "",
                component: (0, jsx_runtime_1.jsx)(HomeLegalExpensesBanner_1.HomeLegalExpensesBanner, __assign({}, this.props))
            });
        }
        var bicycles = (_c = this.props.interaction.bicycles) === null || _c === void 0 ? void 0 : _c.filter(function (bicycle) { return bicycle.flowValuable; });
        if (isGold
            && !(bicycles === null || bicycles === void 0 ? void 0 : bicycles.length)
            && !isBuildingsOnlyCover) {
            banners.push({
                id: 4,
                product: services_1.ProductsEnum.HOME,
                name: "BicyclesBanner",
                link: "",
                component: (0, jsx_runtime_1.jsx)(BicyclesBanner_1.BicyclesBanner, __assign({}, this.props))
            });
        }
        return banners;
    };
    ExtrasCarousel.prototype.getSettings = function (next) {
        if (next) {
            next({ carouselEnabled: true, });
        }
    };
    return ExtrasCarousel;
}(Carousel_1.Carousel));
exports.ExtrasCarousel = ExtrasCarousel;
//# sourceMappingURL=ExtrasCarousel.js.map